
import { Action, createReducer, on } from '@ngrx/store';
import { hideSpinner, hideWarning, showSpinner, showWarning } from '../actions/warning.action';


export interface WarningState {
  key: string;
  summary: string;
  detail: string;
  severity: string;
  sticky: boolean;
  blockedDocument: boolean;
}

export const initialStateW: WarningState = {
  key: '',
  summary: '',
  detail: '',
  severity: '',
  sticky: false,
  blockedDocument: false
};


export const warningReducer = createReducer(
  initialStateW,
  on(showWarning, (state, { key, summary, detail, severity, sticky }) => ({
    ...state,
    key,
    summary,
    detail,
    severity,
    sticky,
    blockedDocument: true
  })),
  on(hideWarning, (state) => ({
    ...state,
    blockedDocument: false
  }))
);




export const initialState = false;


const _spinnerReducer = createReducer(initialState,
  on(showSpinner, state => true),
  on(hideSpinner, state => false),
);

export function spinnerReducer(state: boolean | undefined, action: Action<string>) {
  return _spinnerReducer(state, action);
}